<template>
  <b-container class="px-0">
    <b-row class="pb-2">
      <b-col>
        <b-link :data-test-path="dataTestPath" style="font-size: 17px"
                @click="openImageGallery">
          {{fieldConfig.fieldLabel}} <span>[{{ numberOfImages }}]</span>
        </b-link>
      </b-col>
    </b-row>
    <b-row v-if="!validatedField.isValid">
      <b-col>
        <small style="margin-top: 2px; margin-left: 10px;"
               class="form-text text-danger font-weight-bold">{{validatedField.errorMessage || '&nbsp;' }}
        </small>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>




import FormValidatedField from "@/components/forms/FormValidatedField";
import ActivityManager from "@/activity/ActivityManager";
import ImageGallery from "@/server/com/silkplm/files/images/ImageGallery";
import GalleryFormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/GalleryFormFieldConfig";

const ImageGalleryCard = () => require("@/components/img/ImageGalleryCard");

export default {
  name: "GalleryRenderer",
  components: {},
  mounted() {
    this.loadGallery();
    this.dataTestPath = "number-of-image-gallery" + "-" + this.validatedField.validatedForm.formConfig.formClassLong;
  },
  props: {
    validatedField: {type: FormValidatedField, required: true},
    fieldConfig: {type: GalleryFormFieldConfig, required: true},
  },

  methods: {
    setReadOnly(readOnly) {
      this.readOnly = readOnly;
    },
    setEditorMode(val) {
      this.editorMode = val;
    },

    getGalleryData() {
      let result = {
        "numberOfImages" : this.numberOfImages,
        "imagesList" : this.imagesList,
        "listOfImagesInGalleryCard" : this.listOfImagesInGalleryCard,
      }
      return result;
    },

    setGalleryData(result) {
      this.numberOfImages = result["numberOfImages"];
      this.imagesList = result["imagesList"];
      this.listOfImagesInGalleryCard = result["listOfImagesInGalleryCard"];
    },

    async loadGallery() {
      if (this.validatedField.value && this.validatedField.value.imagesList) {
        this.numberOfImages = this.validatedField.value.imagesList.length;
        this.imagesList = [...this.validatedField.value.imagesList];
      } else {
        this.numberOfImages = 0;
        this.imagesList = [];
      }
    },

    async openImageGallery() {

      let entityId = this.validatedField.validatedForm?.originalSource?.id;

      if (this.imagesList != null && this.imagesList.length > 0) {
        this.imagesList.sort((a, b) => a.data.name.toLowerCase() > b.data.name.toLowerCase() ? 1 : -1);
        this.listOfImagesInGalleryCard = this.imagesList;

        for(let image of this.listOfImagesInGalleryCard) {
          image.starState = "star-outline"

          if (image.customData) {
            if (image.customData.imageTagList.find(tag => tag.name === "Main Picture")) {
              image.starState = "star"
            }
          }
        }

      } else {
        this.listOfImagesInGalleryCard = [];
      }

      let imageGalleryCard = await ActivityManager.showActivity(ImageGalleryCard, {
        numberOfUnsavedImages: this.numberOfUnsavedImages,
        listOfImagesInGalleryCard: this.listOfImagesInGalleryCard,
        originalListOfImages: this.imagesList,
        isJoined: this.fieldConfig.joined,
        formConfig: this.validatedField.validatedForm.formConfig
      });

      imageGalleryCard.$on("save", async () => {
        let imageGalleryCardResult = await imageGalleryCard.getResult();
        if (imageGalleryCardResult) {
          this.imagesList = imageGalleryCardResult.listOfImagesInGalleryCard;
          this.numberOfUnsavedImages = imageGalleryCardResult.numberOfUnsavedImages;
          this.numberOfImages = this.imagesList.length;
          if (this.validatedField.value == null) {
            this.validatedField.value = new ImageGallery();
          }
          // // to przypisanie musi koniecznie wywołać setter, tak by wywołała się w tle walidacja wykonana w setterze
          let gallery = this.validatedField.value;
          gallery.imagesList = this.imagesList;
          this.validatedField.value = gallery;
          if (entityId) {
            await this.validatedField.saveField();
          }
        }
      });
    },
  },
  watch: {
    'validatedField': function (val) {
      this.loadGallery();
    },
    'validatedField.value': function (val) {
      this.loadGallery();
    },
    'validatedField.value.imagesList': function (val) {
      this.loadGallery();
    }
  },
  data: () => ({
    dataTestPath: "",
    readOnly: true,
    editorMode: false,
    numberOfImages: 0,
    numberOfUnsavedImages: 0,
    imagesList: [],
    listOfImagesInGalleryCard: [],
  })
}
</script>

<style scoped>

</style>

